import { LoaderFunction } from 'react-router-dom';

export interface CalendarEvent {
  id: string;
  typeLabel: string;
  title: string;
  dateString: string;
  timeRange: string;
  location?: string | null;
  instructor?: string | null;
  status: 'not_started' | 'in_progress';
}

export interface CalendarLoaderProps {
  calendarEvents: CalendarEvent[];
}

const calendarEvents: CalendarEvent[] = [
  {
    id: 'event-sep-1',
    typeLabel: 'INSTRUCTOR-LED TRAINING',
    title: 'Managing Jira service projects (public class)',
    dateString: 'Friday, Sep 26, 2025',
    timeRange: '4:30 PM to 12:30 AM EEST',
    location: 'Register on Partner Site',
    instructor: 'Work Wranglers',
    status: 'in_progress',
  },
  {
    id: 'event-sep-2',
    typeLabel: 'CLOUD MIGRATION',
    title: 'Cloud Migration Simulation Sign-Up - Cloud Migration Simulation - September 29, 2025 - October 3, 2025',
    dateString: 'Monday, Sep 29, 2025',
    timeRange: '10:00 AM to 10:00 AM EEST',
    location: 'Online, remote',
    instructor: null,
    status: 'not_started',
  },
  {
    id: 'event-sep-3',
    typeLabel: 'INSTRUCTOR-LED TRAINING',
    title: 'Managing Jira projects (public class)',
    dateString: 'Monday, Sep 29, 2025',
    timeRange: '5:00 PM to 1:00 AM EEST',
    location: 'Register on Partner Site',
    instructor: 'Work Wranglers',
    status: 'in_progress',
  },
  {
    id: 'event-oct-1',
    typeLabel: 'CLOUD MIGRATION',
    title: 'Cloud Migration Simulation Sign-Up - Cloud Migration Simulation - October 6, 2025 - October 10, 2025',
    dateString: 'Monday, Oct 6, 2025',
    timeRange: '10:00 AM to 10:00 AM EEST',
    location: 'Online, remote',
    instructor: null,
    status: 'not_started',
  },
  {
    id: 'event-oct-2',
    typeLabel: 'INSTRUCTOR-LED TRAINING',
    title: 'Jira automation (public class)',
    dateString: 'Monday, Oct 6, 2025',
    timeRange: '4:00 PM to 12:00 AM EEST',
    location: 'Register on Partner Site',
    instructor: 'Workwranglers',
    status: 'in_progress',
  },
  {
    id: 'event-oct-3',
    typeLabel: 'INSTRUCTOR-LED TRAINING',
    title: 'Managing Confluence Spaces (public class)',
    dateString: 'Wednesday, Oct 8, 2025',
    timeRange: '7:00 PM to 11:00 PM EEST',
    location: 'Register on Partner Site',
    instructor: 'Work Wranglers',
    status: 'in_progress',
  },
  {
    id: 'event-oct-4',
    typeLabel: 'INSTRUCTOR-LED TRAINING',
    title: 'Managing Jira projects (public class)',
    dateString: 'Thursday, Oct 9, 2025',
    timeRange: '1:00 AM to 9:00 AM EEST',
    location: 'Register on Partner Site',
    instructor: 'GLINTECH',
    status: 'in_progress',
  },
  {
    id: 'event-oct-5',
    typeLabel: 'INSTRUCTOR-LED TRAINING',
    title: 'Jira essentials with agile mindset (public class)',
    dateString: 'Monday, Oct 13, 2025',
    timeRange: '5:00 PM to 1:00 AM EEST',
    location: 'Register on Partner Site',
    instructor: 'Work Wranglers',
    status: 'in_progress',
  },
];

export const loader: LoaderFunction = async (): Promise<CalendarLoaderProps> => ({
  calendarEvents,
});
